// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"35":"c54777cc","58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","458":"ab3258c9","577":"66801e42","652":"5c7fb476","660":"0f6508c5","682":"d5252985","783":"c66ca607","812":"e16e9c63","867":"5d6a6d26","904":"0c67cfd9","985":"de897744","995":"49583948"}[chunkId] + ".js";
};